import React, {useEffect, useState} from 'react';
import {useParams} from "react-router";
import {navigateHook} from "../../../../hooks/use-navigate.js";
import {useQuery} from "@tanstack/react-query";
import {toast} from "react-toastify";
import projectUtils from "../../../../utils/project-utils.js";
import {Template} from "../../../../components/template/template.jsx";
import Button from "../../../../components/button/button.jsx";
import {FaInfoCircle, FaPlus} from "react-icons/fa";
import {Card} from "../../../../components/card/card.jsx";
import InputForm from "../../../../components/input/input-form.jsx";
import Alert from "../../../../components/alert/alert.jsx";
import individualMonitoringWatchlistService, {
    INDIVIDUAL_MONITORING_WATCHLIST_QUERY_KEYS
} from "../../../../services/web/individual-monitoring-watchlist-service.js";

const IndividualMonitoringWatchlistForm = () => {
    const {id} = useParams();
    const navigate = navigateHook();

    const [state, setState] = useState("")

    const {data, refetch} = useQuery({
        queryFn: () => individualMonitoringWatchlistService.get(id),
        queryKey: INDIVIDUAL_MONITORING_WATCHLIST_QUERY_KEYS.detail(id),
        enabled: !!id,
        staleTime: 0
    });

    useEffect(() => {
        if (!!id && data) {
            setState(data.name);
        } else  {
            setState("");
        }
    }, [id, data]);

    const submit = () => {
        let response;
        if (id) response = individualMonitoringWatchlistService.edit({id, name: state});
        else response = individualMonitoringWatchlistService.create({name: state});

        response
            .then((data) => {
                projectUtils.success(!id);

                if (id) {
                    refetch();
                    return;
                }

                const urlDev = `/individual-monitoring-watchlist/form/${data}`;
                navigate(urlDev);
            })
            .catch(error => {
                console.error(error);
                let message = 'Não foi possível salvar.';
                if (error.response.status !== 500) {
                    message = translateError(error.response.data.message);
                }

                projectUtils.swalErrorMessage('', message, 'Ok');
            });
    }

    const deleteWatchList = () => {
        projectUtils.swalMessage(
            "warning",
            "Excluir",
            `Excluir o motivo do monitoramento "${data.name}"?`,
            "Sim",
            true,
            "Não",
            ({isConfirmed}) => {
                if (isConfirmed) {
                    individualMonitoringWatchlistService.delete(id)
                        .then(() => {
                            projectUtils.success(true, "Excluído com sucesso");
                            navigate("/individual-monitoring-watchlist");
                        })
                        .catch(error => {
                            console.error(error);
                            let message = 'Não foi possível excluir.';
                            if (error.response.status !== 500) {
                                message = translateError(error.response.data.message, 'Não foi possível excluir.');
                            }

                            projectUtils.swalErrorMessage('', message, 'Ok');
                        });
                }
            }
        );
    }

    function translateError(message, defaultMessage = "Não foi possível salvar.") {
        const i18n = {
            "watchlist.is.system": "Não é possível alterar ou excluir um motivo de sistema",
            "watchlist.in.use": "Esse motivo possui um monitoramento vinculado.",
            "watchlist.cannot.be.null": "O campo \"Nome\" é obrigatório.",
            "watchlist.duplicated.name": "Este \"Nome\" já está sendo utilizado.",
            "facialrecognition.watchlist.limit.reached": "Limite de listas de motivos cadastrados atingido.",
            "facegateway.not.configured": "Sistema de reconhecimento facial não configurado."
        }

        return i18n[message] ?? defaultMessage
    }

    return (
        <Template>
            <Template.Header>
                <Template.Title>Lista de monitoramento</Template.Title>

                {
                    id &&
                    <Button target={"default"} onClick={() => navigate("/individual-monitoring-watchlist/form")}>
                        <FaPlus /> Adicionar item na lista de monitoramento
                    </Button>
                }
            </Template.Header>

            <Template.Body className={"space-y-2"}>
                <Card>
                    <Card.Body>
                        <InputForm
                            id={"name"}
                            label={"Nome *"}
                            value={state}
                            onChange={({target: {value}}) => setState(value)}
                            disabled={id && data?.system}
                        />
                    </Card.Body>
                </Card>

                <Card>
                    <Card.Body className={"flex justify-end gap-2"}>
                        {
                            id && data?.system ?
                                <Alert className={"flex gap-2 items-center"} target={"info"}>
                                    <FaInfoCircle /> Esse é um item padrão de sistema e não pode ser editado ou excluído.
                                </Alert>
                                :
                                <>
                                    {
                                        id &&
                                        <Button target={"danger"} onClick={deleteWatchList} actionFeedbackType='delete'>

                                            Excluir
                                        </Button>
                                    }
                                    <Button onClick={submit} actionFeedbackType='save'>

                                        Salvar
                                    </Button>
                                </>
                        }
                    </Card.Body>
                </Card>
            </Template.Body>
        </Template>
    );
};

export default IndividualMonitoringWatchlistForm;